import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { AlertTriangle, X } from 'lucide-react';

const PastDateWarningModal = ({
    open,
    setOpen,
    selectedDate = '',
    onProceed,
    onCancel,
}) => {
    const handleClose = () => {
        setOpen(false);
        if (onCancel) {
            onCancel();
        }
    };

    const handleProceed = () => {
        setOpen(false);
        if (onProceed) {
            onProceed();
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} className='relative z-50'>
            <DialogBackdrop className='fixed inset-0 bg-black/50' />

            <div className='fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto'>
                <DialogPanel className='bg-white rounded-lg shadow-xl max-w-md w-full'>
                    {/* Header */}
                    <div className='flex items-center justify-between p-6 pb-4'>
                        <DialogTitle className='text-lg font-semibold text-gray-900 flex items-center space-x-3'>
                            <AlertTriangle className='h-6 w-6 text-amber-600' />
                            <span>Date Selection Warning</span>
                        </DialogTitle>
                        <button
                            onClick={handleClose}
                            className='p-1 rounded-lg transition-colors duration-200 text-gray-400 hover:text-gray-600 hover:bg-gray-100'
                        >
                            <X className='h-5 w-5' />
                        </button>
                    </div>
                    {/* Content */}
                    <div className='px-6 pb-6'>
                        <div className='mb-6'>
                            <p className='text-gray-700 mb-3 text-sm'>
                                <strong>Warning:</strong> You are trying to select a date that has already passed. This may cause issues with your order.
                            </p>
                            {selectedDate && (
                                <div className='bg-amber-50 border border-amber-200 rounded-lg p-3'>
                                    <p className='text-sm text-gray-600 mb-1'>Selected date:</p>
                                    <p className='font-semibold text-gray-900'>{selectedDate}</p>
                                </div>
                            )}
                            <p className='text-gray-600 text-sm mt-3'>
                                Are you sure you want to proceed with this past date?
                            </p>
                        </div>

                        {/* Action Buttons */}
                        <div className='flex items-center justify-end space-x-3'>
                            <button
                                onClick={handleClose}
                                className='px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 text-gray-700 bg-gray-100 hover:bg-gray-200'
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleProceed}
                                className='px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 bg-primary-100 text-white hover:bg-amber-700'
                            >
                                Yes, Proceed
                            </button>
                        </div>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default PastDateWarningModal;
